import { render, staticRenderFns } from "./AttendeeSettings.vue?vue&type=template&id=0071f578&"
import script from "./AttendeeSettings.vue?vue&type=script&lang=js&"
export * from "./AttendeeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports